import React from 'react';
import { useTheme } from '../../context/ThemeContext';

export function DarkModeToggle() {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <button
      onClick={toggleDarkMode}
      className={`
        relative inline-flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors
        ${isDarkMode 
          ? 'bg-blue-600 text-white hover:bg-blue-500' 
          : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
        }
      `}
      title={isDarkMode ? 'Schakel naar lichte modus' : 'Schakel naar donkere modus'}
    >
      <div className="flex items-center space-x-2">
        {isDarkMode ? (
          // Sun icon for light mode
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path 
              fillRule="evenodd" 
              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" 
              clipRule="evenodd" 
            />
          </svg>
        ) : (
          // Moon icon for dark mode
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
          </svg>
        )}
        <span className="hidden sm:inline">
          {isDarkMode ? 'Licht' : 'Donker'}
        </span>
      </div>
    </button>
  );
}